import {
    CoreModule,
    UiBaseModule,
    AuthByKT1Module,
    KnowledgeBaseModule,
    TaskManagerModule,
    UiBaseModuleConfig,
    UiBaseViewNames,
    KnowledgeBaseModuleConfig,
    RecordTypeConfig,
    KbEventRecord,
    EwoDefinitionModule,
    itLang, enLang
} from "@kta20-webapp/profiles/etm-newkb/imports";
import {ViewNames} from "@kta20-knowledge-base/constants";


export default  (EnvProps)=> {
    EnvProps;
    return {
        Modules : {
            CoreModule,
            UiBaseModule,
            AuthByKT1Module,
            KnowledgeBaseModule,
            TaskManagerModule,
            EwoDefinitionModule
        },
        Config : [
            new UiBaseModuleConfig([
                UiBaseViewNames.SINGLE_NAV_LAYOUT_VIEW
            ]),
            new KnowledgeBaseModuleConfig(
                EnvProps.URIs.knowledgeBaseURI,
                [
                    <RecordTypeConfig>{
                        id:KbEventRecord.CLASS_NAME,
                        iconSVGFromResources: 'BELL',
                        detailsViewName:ViewNames.KB_RECORD_DETAILS_VIEW,
                        detailsTitleFieldName:'title',
                        labels: {
                            en: "EWO",
                            it: "EWO"
                        },
                        sourceModelLabels:{
                            en:enLang,
                            it:itLang
                        }
                    }
                ]
            )
        ]
    }
};